import { Component, OnInit } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  public version = '2024-10-31' // used only for re-building the app

  constructor(
    private translateService: TranslateService
  ) {}

  public ngOnInit(): void {
    this.translateService.setDefaultLang('en')
  }
}
